import { ReactNode } from 'react';

export enum Panels {
    CONTEXT = 'context',
    AMBIENT = 'ambient',
    DESIGN_SCHEMES = 'designSchemes',
    SOLAR_ENERGY_RESOURCES = 'solarEnergyResources',
    PERFORMANCE_METRICS = 'performanceMetrics',
    SETTINGS = 'settings',
    DATA = 'data',
    FILTER = 'filter',
    GEODATA = 'geodata',
    OVERLAYS = 'overlays',
}

export enum HeaderDialogType {
    SETTINGS,
    CONTEXT,
    CAMERA,
    SOLAR_ENERGY_RESOURCES,
    EDIT_GEODATA,
    EXPORT,
    OBSERVATIONS,
    DATA_SOURCES,
    SUGGESTIONS,
    BACK,
    COMPASS,
    LEGEND,
    FULL_SCREEN,
    FPS_INDICATOR,
    STATE,
    REPORT_ISSUE,
    USER_GUIDE,
}

export type SideDialog = {
    type: HeaderDialogType;
    Icon: React.ReactNode;
    title: string;
    content?: ReactNode;
    onClick?: () => void;
    tooltip?: string;
    btnID?: string;
};
